<template>
  <div class="card">
    <figure class="m-0 p-0">
      <img loading="lazy" width="300" height="200" :src="image.src" :alt="image.alt" />
    </figure>
    <div class="content">
      <prismic-rich-text :title="title[0].text" class="title prismic-rich-text" :field="title" />
      <prismic-rich-text
        :title="description[0].text"
        class="description prismic-rich-text"
        :field="description"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: Object,
      required: true
    },
    title: {
      type: Array,
      required: true
    },
    description: {
      type: Array,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  display: grid;
  aspect-ratio: 340/360;
  grid-template-rows: 1fr 1fr 1fr;
  background: var(--primary-color);
  color: var(--texts-color);
  border-radius: 20px;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  figure {
    grid-row: span 2;
  }
  .prismic-rich-text {
    ::v-deep > * {
      margin: inherit;
      font-size: inherit;
    }
  }
  .content {
    grid-row: span 1;
    display: grid;
    align-content: start;
    gap: 0.5em;
    padding: 1em;
    @include min-lg {
      padding: 1em 1.5em;
    }
    .title {
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      line-clamp: 1;
      -webkit-box-orient: vertical;
      margin: 0;
      font-size: 20px;
      font-weight: 800;
      ::v-deep > * {
        font-weight: inherit;
      }
    }
    .description {
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: var(--description-max-lines, 2);
      line-clamp: var(--description-max-lines, 2);
      -webkit-box-orient: vertical;
      margin: 0;
    }
  }
}
</style>
